import React, { useState } from 'react';
import { InputField } from '@trp-beacon-ui-kit/react-controls';
import { phoneValidation } from '../../flows/shared/validations';
import { handleInputFormat } from '../../flows/shared/utils';
import { MFBeaconButton } from '../../components/Beacon/BeaconComponents';
import plusIcon from '../../assets/images/plus-icon.svg';
import styles from './styles.css';
import { generateGeneralTestID } from '../../generateAutomationTestIDs';

export const AdditionalPhoneNumber = ({
  phone,
  setPhone,
  phoneFormProps,
  phoneClass,
  dataName
}) => {
  const [phoneValue, setPhoneValue] = useState('');
  const deleteButtonDataID = phoneClass?.includes('3')
    ? 'EveningPhoneNumberDeleteButton'
    : 'DaytimePhoneNumberDeleteButton';
  return phone ? (
    <>
      <div className={phoneClass}>
        <InputField
          title="Additional phone number"
          data-name={dataName}
          placeholder="(000) 000-0000"
          onChange={evt => handleInputFormat(evt, 'PHONE', setPhoneValue)}
          maxLength="14"
          autocomplete="new-password"
          validation={phoneValidation}
          {...phoneFormProps}
          value={typeof phone === 'string' ? phone : phoneValue}
          className="blocked_data"
        />
      </div>
      <span className="delete-phone-number-btn">
        <MFBeaconButton
          id={`deletePhoneNumberBtn-${phoneClass}`}
          data-name={generateGeneralTestID(
            'TrusteeContactInformation',
            deleteButtonDataID
          )}
          className="override-beacon-button-padding"
          onClick={() => setPhone(false)}
          type="button"
          variant="tertiary"
          label="remove"
        />
      </span>
      <style jsx>{styles}</style>
    </>
  ) : null;
};

/* eslint-disable */

const TrusteeAdditionalPhoneNumberFields = ({ formProps }) => {
  const [phone2, setPhone2] = useState(false);
  const [phone3, setPhone3] = useState(false);

  return (
    <>
      <div className="additional-phone-fields">
        {phone2 && (
          <AdditionalPhoneNumber
            phone={phone2}
            setPhone={setPhone2}
            phoneFormProps={formProps.phone2}
            phoneClass="phone-input2"
            dataName={generateGeneralTestID(
              'TrusteeContactInformation',
              'TrusteeDaytimePhoneNumber'
            )}
          />
        )}

        {phone3 && (
          <AdditionalPhoneNumber
            phone={phone3}
            setPhone={setPhone3}
            phoneFormProps={formProps.phone3}
            phoneClass={phone2 && phone3 ? 'phone-input3' : 'input-only-phone3'}
            dataName={generateGeneralTestID(
              'TrusteeContactInformation',
              'TrusteeEveningPhoneNumber'
            )}
          />
        )}

        {!phone3 && (
          <span className={phone2 ? 'add-phone-btn2' : 'add-phone-btn'}>
            <MFBeaconButton
              id="addTrusteePhoneBtn"
              data-name={generateGeneralTestID(
                'TrusteeContactInformation',
                'AddPhoneNumberButton'
              )}
              onClick={() => (phone2 ? setPhone3(true) : setPhone2(true))}
              className={phone2 ? 'add-phone3' : 'add-phone2'}
              type="button"
              variant="tertiary"
              icon-align="left"
              label="Add another phone number">
              <img
                slot="icon"
                className="plus-icon"
                src={plusIcon}
                alt="plus icon"
              />
            </MFBeaconButton>
          </span>
        )}
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default TrusteeAdditionalPhoneNumberFields;
